import { render, staticRenderFns } from "./MyPagination.vue?vue&type=template&id=5a3d0599&"
import script from "./MyPagination.vue?vue&type=script&lang=js&"
export * from "./MyPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports